module.exports = __webpack_public_path__ + "static/img/cjwt.3a39f23a.png";